import { CompanyActionTypes } from './constants';

const COMPANY_DATA_INITIAL_STATE = {
    companyData: [],
    loading: false,
};


const companyDataReducer = (state = COMPANY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case CompanyActionTypes.GET_COMPANY_DATA_LOADING:
            return {
                companyData: state.companyData,
                loading: true,
            };
        case CompanyActionTypes.GET_COMPANY_DATA_SUCCESS:
            return {
                companyData: action.payload,
                loading: false,
            };
        case CompanyActionTypes.GET_COMPANY_DATA_ERROR:
            return {
                companyData: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};
const companyDetailsDataReducer = (state = COMPANY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case CompanyActionTypes.GET_COMPANY_DETAILS_DATA_LOADING:
            return {
                companyData: state.companyData,
                loading: true,
            };
        case CompanyActionTypes.GET_COMPANY_DETAILS_DATA_SUCCESS:
            return {
                companyData: action.payload,
                loading: false,
            };
        case CompanyActionTypes.GET_COMPANY_DETAILS_DATA_ERROR:
            return {
                companyData: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};
const createCompanyDataReducer = (state = COMPANY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case CompanyActionTypes.CREATE_COMPANY_DATA_LOADING:
            return {
                companyData: state.companyData,
                loading: true,
            };
        case CompanyActionTypes.CREATE_COMPANY_DATA_SUCCESS:
            return {
                companyData: action.payload,
                loading: false,
            };
        case CompanyActionTypes.CREATE_COMPANY_DATA_ERROR:
            return {
                companyData: action.payload ,
                loading: false,
            };
        case CompanyActionTypes.RESET_COMPANY_STATE:
            return {
                companyData: [],
                loading: false,
            };
        default:
            return state;
    }
};
const updateCompanyDataReducer = (state = COMPANY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case CompanyActionTypes.UPDATE_COMPANY_DATA_LOADING:
            return {
                companyData: action.payload,
                loading: true,
            };
        case CompanyActionTypes.UPDATE_COMPANY_DATA_SUCCESS:
            return {
                companyData: action.payload,
                loading: false,
            };
        case CompanyActionTypes.UPDATE_COMPANY_DATA_ERROR:
            return {
                companyData: action.payload ,
                loading: false,
            };
        case CompanyActionTypes.RESET_COMPANY_STATE:
            return {
                companyData: [],
                loading: false,
            };
        default:
            return state;
    }
};
const deleteCompanyDataReducer = (state = COMPANY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case CompanyActionTypes.DELETE_COMPANY_DATA_LOADING:
            return {
                companyData: action.payload,
                loading: true,
            };
        case CompanyActionTypes.DELETE_COMPANY_DATA_SUCCESS:
            return {
                companyData: action.payload,
                loading: false,
            };
        case CompanyActionTypes.DELETE_COMPANY_DATA_ERROR:
            return {
                companyData: action.payload ,
                loading: false,
            };
        case CompanyActionTypes.RESET_COMPANY_STATE:
            return {
                companyData: [],
                loading: false,
            };
        default:
            return state;
    }
};


export { companyDataReducer, companyDetailsDataReducer, createCompanyDataReducer, updateCompanyDataReducer, deleteCompanyDataReducer };
